module.exports = __webpack_public_path__ + "6.jpg?ff1544b7bc750f0ee50743ccc6746d5c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resources/img/6.jpg
// module id = 61
// module chunks = 0